import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  InputField,
  Modal,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import { nanoid } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface GoogleOTPLoginModalProps {
  open: boolean;
  requestId: string;
  onClose: () => void;
}
const GoogleOTPLoginModal: React.FC<GoogleOTPLoginModalProps> = ({
  open,
  requestId,
  onClose,
}) => {
  const toast = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [otp, changeOtp] = useState("");
  const { loginGoogleOtp } = useLoginStore();
  const handleLoginOTPWIthGoogle = async () => {
    let resp = await loginGoogleOtp({ userId: requestId, otp: otp });
    if (resp.payload) {
      navigate(`${process.env.PUBLIC_URL}/home`);
    } else {
      toast.toastMsg(nanoid(), t("login.googleOTP.invalidOTP"), "error");
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("login.googleOTP.login")}
      subTitle={
        <Typography
          type="body4_rg"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
          whiteSpace="break-spaces"
        >
          {t("login.googleOTP.loginDesc")}
        </Typography>
      }
      width={540}
      body={
        <Box direction="column" justifyContent="center" width={"100%"}>
          <InputField
            size="md"
            value={otp}
            maxLength={6}
            onChange={(e) => changeOtp(e.target.value)}
            placeholder={t("login.googleOTP.codePlaceholder")}
            label={t("login.googleOTP.code")}
          />
        </Box>
      }
      footer={
        <Box
          width={"calc(100% + 16px)"}
          justifyContent="space-between"
          alignItems="center"
        >
          <span style={{ marginInlineStart: "-8px" }}>
            <Button
              btnStyle="link"
              leadingIcon={<Icons variant="line" label="exit" />}
              label={t("login.googleOTP.loginDifferentID")}
              onClick={onClose}
            />
          </span>

          <Button
            btnStyle="fill"
            state={otp ? "default" : "disable"}
            label={t("login.title")}
            onClick={handleLoginOTPWIthGoogle}
          />
        </Box>
      }
    />
  );
};
export default GoogleOTPLoginModal;
